import React from 'react';
import { getIntl } from '../../../utils/intl';
import { ContentStack } from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';
import { APITypes } from '../../../primary-record-types';
import Select from '../../v2BaseComponents/Inputs/Select';
import { SelectOption } from '../../v2BaseComponents/Inputs/Select/types';

const intl = getIntl('BulkAddClientProfilesGroups', {
    descriptiveText:
        'Select groups to add {count} client record{plural} to. This will add the selected group to the client record{plural}. If a client record already belongs to one of the groups, it will not be added again.',
    groups: 'Groups',
});

export type BulkAddClientProfilesGroupsOwnProps = {
    selectedGroupIds: string[];
    onSelectedGroupIdsChange: (ids: string[]) => void;
    clientRecordIds: string[];
    organizationGroups: APITypes.organizationService.ListOrganizationGroupsResponse['items'];
};

export type BulkAddClientProfilesGroupsProps = BulkAddClientProfilesGroupsOwnProps;

const BulkAddClientProfilesGroups: React.FC<BulkAddClientProfilesGroupsProps> = (props) => {
    return (
        <ContentStack>
            <Text variant="body-1">
                {intl('descriptiveText', {
                    count: props.clientRecordIds.length,
                    plural: props.clientRecordIds.length === 1 ? '' : 's',
                })}
            </Text>
            <Select
                multiple={true}
                selectOptions={props.organizationGroups
                    .map<SelectOption>((group) => ({
                        label: group.metadata.name,
                        value: group.organizationGroupId,
                        testID: group.metadata.name,
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))}
                value={(props.selectedGroupIds || []) as any}
                onChange={(groupIds) => props.onSelectedGroupIdsChange(groupIds || [])}
                title={intl('groups')}
                testID="edit-client-records-groups-select"
                forceFullWidth
            />
        </ContentStack>
    );
};

export default React.memo(BulkAddClientProfilesGroups);
